import {
  Grid,
  GridCell,
  GridCellProps,
  GridColumn,
  GridDetailRowProps,
  GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import GridWrapper from "../../grid/GridWrapper";
import { planoProduitHeaders } from "../../../constante/planoProduitHeaders";
import { Tooltip } from "@mui/material";
import { useGetPlanogrammeProduitsQuery } from "../../../redux/features/cache";

interface ProductNameHeaderProps extends GridHeaderCellProps {
  children: any;
}

export default function DetaillProduitComponent(props: GridDetailRowProps) {
  const { data: planogrammeProduits } = useGetPlanogrammeProduitsQuery(
    props.dataItem.plano_seq
  );
  const HeaderWithTri = (
    props: ProductNameHeaderProps & { tooltip: string }
  ) => {
    let tooltipParagraphs: JSX.Element[] = [];

    if (props.tooltip !== undefined) {
      tooltipParagraphs = (props.tooltip || "")
        .split(/(?=\b\w+:)/)
        .map((segment, index) => <p key={index}>{segment.trim()}</p>);
    }
    const isEmptyTooltip =
      tooltipParagraphs.length === 1 &&
      tooltipParagraphs[0].props.children === "";

    return (
      <>
        {!isEmptyTooltip ? (
          <Tooltip title={tooltipParagraphs}>
            <span>{props.title}</span>
          </Tooltip>
        ) : (
          <>
            <span>{props.title}</span> {props.children}
          </>
        )}
      </>
    );
  };

  const StatutCell = (props: GridCellProps) => {
    return (
      <td
        style={{
          color:
            props.dataItem[props.field!] === "Manquant" ? "red" : "inherit",
        }}
        colSpan={1}
        className="k-table-td"
        role="gridcell"
        aria-colindex={2}
        aria-selected="false"
        data-grid-col-index="1"
      >
        {props.dataItem[props.field!]}
      </td>
    );
  };

  const IndicateurCell = (props: GridCellProps) => {
    let text = props.dataItem.field_highlight ? "*" : "";

    return (
      <td
        colSpan={1}
        className="k-table-td"
        role="gridcell"
        aria-colindex={1}
        aria-selected="false"
        style={{ paddingBlock: "4px", paddingInline: "6px" }}
        data-grid-col-index="0"
        ref={(node) => {
          if (node && text) {
            node.style.setProperty(
              "background-color",
              props.dataItem.field_highlight ? "yellow" : "#0257d5",
              "important"
            );
            node.style.setProperty(
              "color",
              props.dataItem.field_highlight ? "black" : "white",
              "important"
            );
          }
        }}
      >
        <span style={{ fontWeight: "bold" }}>{text}</span>
      </td>
    );
  };

  return (
    <GridWrapper>
      <Grid data={planogrammeProduits} reorderable={true} resizable>
        {planoProduitHeaders.map((item: any, index: any) => (
          <GridColumn
            headerCell={(props) => (
              <HeaderWithTri {...props} tooltip={item.tooltip} />
            )}
            field={item.champ}
            key={item.label_champ + index}
            title={item.label_champ}
            format={item.format_champ}
            headerClassName={`${
              item.format_champ === "{0:c}" ? "alignRight" : ""
            }`}
            className={`${item.format_champ === "{0:c}" ? "alignRight" : ""}`}
            width={item.width}
            cell={(props) => {
              let cell =
                item.customCell === "statutCell" ? (
                  <StatutCell {...props} />
                ) : item.customCell === "indicateurCell" ? (
                  <IndicateurCell {...props} />
                ) : (
                  <GridCell
                    {...props}
                    style={{
                      color: props.dataItem.field_highlight
                        .toUpperCase()
                        .split(",")
                        .includes(item.champ.toUpperCase())
                        ? "red"
                        : "black",
                    }}
                  />
                );
              return cell;
            }}
          />
        ))}
      </Grid>
    </GridWrapper>
  );
}
